import React from 'react';
import { cn } from '../../lib/utils';

export interface InspectorSectionProps {
  title: string;
  description?: string;
  children: React.ReactNode;
  className?: string;
}

export function InspectorSection({
  title,
  description,
  children,
  className,
}: InspectorSectionProps) {
  return (
    <div className={cn('space-y-4', className)}>
      <div className="space-y-1">
        <h3 className="text-[10px] font-black uppercase tracking-widest text-muted-foreground/80">
          {title}
        </h3>
        {description && (
          <p className="text-xs text-muted-foreground leading-relaxed">
            {description}
          </p>
        )}
      </div>
      <div className="px-0.5">
        {children}
      </div>
    </div>
  );
}
